import {defineStore} from "pinia";
import {IndexCompetition} from "@/types/Competition";
import {competitionService, CompetitionsOverview} from "@/modules/competition/service/CompetitionService";
import {CompetitionParticipationWithActivity} from "@/service/RiderMasterlistService";
import {profileService} from "@/modules/profile/service/ProfileService";
import {Channel} from "@/types/Channel";
import {useCalendarFilterStore} from "@/modules/home/filter/store/CalendarFilterStore";

function getFilterContext() {
    return useCalendarFilterStore().getFilterContext
}

function filterKeyword() {
    return useCalendarFilterStore().keyword
}

function filterCompetitions(list: Array<IndexCompetition>): Array<IndexCompetition> {
    const keyword = filterKeyword()
    if (keyword && keyword.trim() !== "") {
        return list.filter(it => it.name.toLowerCase().includes(keyword.toLowerCase()))
    } else {
        return list
    }
}

export const useCompetitionStore = defineStore('competitionStore', {
    state: () => {
        return {
            loading: false,

            responseToday: [] as Array<IndexCompetition>,
            responseThisWeek: [] as Array<IndexCompetition>,
            responseOther: {lastWeek: [], nextWeek: [], older: [], later: []} as CompetitionsOverview,

            today: [] as Array<IndexCompetition>,
            thisWeek: [] as Array<IndexCompetition>,
            lastWeek: [] as Array<IndexCompetition>,
            nextWeek: [] as Array<IndexCompetition>,
            older: [] as Array<IndexCompetition>,
            later: [] as Array<IndexCompetition>,

            channels: [] as Array<Channel>,

            personMasterlistEntries: [] as Array<CompetitionParticipationWithActivity>

        }
    },
    getters: {
        hasCompetitions(): boolean {
            return (
                this.today.length > 0 ||
                this.thisWeek.length > 0 ||
                this.lastWeek.length > 0 ||
                this.nextWeek.length > 0 ||
                this.older.length > 0 ||
                this.later.length > 0
            )
        },
        personMasterlistEntryCount(): number {
            return this.personMasterlistEntries.map(it => it.entries.length).reduce((a, b) => a + b, 0)
        }
    },
    actions: {
        reload() {
            this.startLoading()
            Promise.all([
                // this.loadChannels(),
                this.loadToday()
            ])
                .then(() => {
                    this.stopLoading()
                    this.loadThisWeek()
                    this.loadOther()
                })
        },
        async loadAll() {
            await this.loadToday()
            await this.loadThisWeek()
            await this.loadOther()
            // await this.loadChannels()
        },
        async loadToday() {
            this.responseToday = await competitionService.searchTodayCompetitions(getFilterContext())
            this.today = filterCompetitions(this.responseToday)
        },
        async loadThisWeek() {
            this.responseThisWeek = await competitionService.searchThisWeekCompetitions(getFilterContext())
            this.thisWeek = filterCompetitions(this.responseThisWeek)
        },
        async loadOther() {
            this.responseOther = await competitionService.searchOtherCompetitions(getFilterContext())
            this.lastWeek = filterCompetitions(this.responseOther.lastWeek)
            this.nextWeek = filterCompetitions(this.responseOther.nextWeek)
            this.later = filterCompetitions(this.responseOther.later)
            this.older = filterCompetitions(this.responseOther.older)
        },
        updateFilteredItems() {
            this.today = filterCompetitions(this.responseToday)

            this.thisWeek = filterCompetitions(this.responseThisWeek)

            this.lastWeek = filterCompetitions(this.responseOther.lastWeek)
            this.nextWeek = filterCompetitions(this.responseOther.nextWeek)
            this.later = filterCompetitions(this.responseOther.later)
            this.older = filterCompetitions(this.responseOther.older)
        },
        async loadPersonMasterlist() {
            this.personMasterlistEntries = await profileService.getTodayMasterlistWidget()
        },
        async loadChannels() {
            // this.channels = await channelService.getFeatured()
        },
        startLoading() {
            this.loading = true
        },
        stopLoading() {
            this.loading = false
        }
    }
})